// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2jm9O","right":"styles_right__SIigc"};